import React from 'react';
import numeral from 'numeral';
import TrueImpactModal from 'shared/design-system/components/TrueImpactModal';
import { Table, TableBody, TableCell, TableHead, Typography } from '@mui/material';
import { useStyles, TableRoot, TableRow, Heading, RowH, ColH, LinkClear, CloseIcon } from './styles';

const Row: React.FC = ({ row }) => (
  <TableRow>
    <TableCell align="left">{row.id}</TableCell>
    <TableCell align="left">{row.name}</TableCell>
    <TableCell align="left">{row.report.name}</TableCell>
    <TableCell align="left">{row.report.status}</TableCell>
    <TableCell align="left">{row.report.stage}</TableCell>
    <TableCell align="left">{`$${numeral(row?.investment?.total||0).format(0, 0)}`}</TableCell>
  </TableRow>
);

const DonorsModal: React.FC = ({ open, setOpen, account, handleClose }) => {
    return (
      <TrueImpactModal
        open={open}
        hideHeader={true}
        next={{
          text: 'Done',
          onClick: () => setOpen(false),
        }}
        onClose={() => setOpen(false)}
      >
        <Heading>
          <CloseIcon onClick={handleClose} />
          <RowH>
            <ColH>
              <Typography variant="h2">Donor List</Typography>
              <br/>
              <Typography variant="body1">Below is a comprehensive list of funding accounts that have contributed to a report managed by the
              grantee account <b>{account?.name||'-'}</b>. This includes all donors who have made financial contributions.</Typography>
            </ColH>
          </RowH>
          <RowH>
            <ColH><span>Selected account: {account?.name||'-'} (ID: {account?.dbId})</span></ColH>
          </RowH>
        </Heading>
        <TableRoot>
          <Table aria-label="accounts table">
              <TableHead>
                  <TableRow>
                      <TableCell align="left">ID</TableCell>
                      <TableCell align="left">Funder Name</TableCell>
                      <TableCell align="left">Funded Report</TableCell>
                      <TableCell align="left">Report Status</TableCell>
                      <TableCell align="left">Report Stage</TableCell>
                      <TableCell align="left">Total Funded</TableCell>
                  </TableRow>
              </TableHead>
              <TableBody>
                {account.funders.map((funder) => (
                  <Row
                    key={funder.id}
                    row={funder}
                  />
                ))}
              </TableBody>
          </Table>
        </TableRoot>
      </TrueImpactModal>
    );
};

export default DonorsModal;
